module.exports = __webpack_public_path__ + "static/media/arrow-blue.a5888925.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-blue.png
// module id = 292
// module chunks = 33